import { render, staticRenderFns } from "./cpEditarServico.vue?vue&type=template&id=c2baef9e&scoped=true&"
import script from "./cpEditarServico.vue?vue&type=script&lang=js&"
export * from "./cpEditarServico.vue?vue&type=script&lang=js&"
import style0 from "./cpEditarServico.vue?vue&type=style&index=0&id=c2baef9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2baef9e",
  null
  
)

export default component.exports